// Background fetch of every page of one docs project, so search can look inside the pages.
// Two rules keep it safe at any size: only a few requests are in flight at once, and an answer
// that arrives after the person has moved to another project is dropped (the search index is
// keyed by page name alone, so a late answer from the old project would show its text as the
// new project's snippets). triage FE-05-06.
export const PREFETCH_PARALLEL = 6;

export async function prefetchPages(slugs, fetchPage, isCurrent, onPage, parallel = PREFETCH_PARALLEL) {
  const queue = [...slugs];
  const worker = async () => {
    while (queue.length && isCurrent()) {
      const slug = queue.shift();
      try {
        const res = await fetchPage(slug);
        if (isCurrent()) onPage(slug, res);
      } catch {
        // A page that cannot be read is simply not searchable; opening it shows the real error.
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(parallel, queue.length) }, worker));
}
